export function virtualCameraRestoreDelay(attempt) {
  const normalizedAttempt = Math.max(1, Math.floor(Number(attempt) || 1));
  return Math.min(500 * (2 ** (normalizedAttempt - 1)), 5000);
}

export function canAttemptVirtualCameraRestore({
  rendererReady,
  runtimeAvailable,
  runtimeConnected,
  runtimeSatisfiesDesiredMode,
  inFlight,
  retryScheduled,
}) {
  return Boolean(
    rendererReady
    && runtimeAvailable
    && runtimeConnected
    && !runtimeSatisfiesDesiredMode
    && !inFlight
    && !retryScheduled,
  );
}

export function virtualCameraRuntimeSatisfied(runtimeStatus) {
  return Boolean(
    runtimeStatus?.available
    && runtimeStatus?.connected
    && runtimeStatus?.status?.cefEnabled
    && runtimeStatus?.status?.vcamStarted,
  );
}
